// @flow
const ADMIN_PROPERTIES = 'admin/server/ADMIN_PROPERTIES';
const ADMIN_PROPERTIES_FAIL = 'admin/server/ADMIN_PROPERTIES_FAIL';
const ADMIN_PROPERTIES_SUCCESS = 'admin/server/ADMIN_PROPERTIES_SUCCESS';

const CREATE_DIR_SVC_DESC = 'admin/server/CREATE_DIR_SVC_DESC';
const CREATE_DIR_SVC_DESC_SUCCESS = 'admin/server/CREATE_DIR_SVC_DESC_SUCCESS';
const CREATE_DIR_SVC_DESC_FAIL = 'admin/server/CREATE_DIR_SVC_DESC_FAIL';

const DELETE_DIR_SVC_DESC = 'admin/server/DELETE_DIR_SVC_DESC';
const DELETE_DIR_SVC_DESC_SUCCESS = 'admin/server/DELETE_DIR_SVC_DESC_SUCCESS';
const DELETE_DIR_SVC_DESC_FAIL = 'admin/server/DELETE_DIR_SVC_DESC_FAIL';

const RESTART_SERVER = 'admin/server/RESTART_SERVER';
const RESTART_SERVER_FAIL = 'admin/server/RESTART_SERVER_FAIL';
const RESTART_SERVER_SUCCESS = 'admin/server/RESTART_SERVER_SUCCESS';

const SEND_DIAGNOSTIC_DATA = 'admin/server/SEND_DIAGNOSTIC_DATA';
const SEND_DIAGNOSTIC_DATA_FAIL = 'admin/server/SEND_DIAGNOSTIC_DATA_FAIL';
const SEND_DIAGNOSTIC_DATA_SUCCESS =
  'admin/server/SEND_DIAGNOSTIC_DATA_SUCCESS';

const SET_BACKUP_CONFIG = 'admin/server/SET_BACKUP_CONFIG';
const SET_BACKUP_CONFIG_FAIL = 'admin/server/SET_BACKUP_CONFIG_FAIL';
const SET_BACKUP_CONFIG_SUCCESS = 'admin/server/SET_BACKUP_CONFIG_SUCCESS';

const SET_BRANDING_SETTINGS = 'admin/server/SET_BRANDING_SETTINGS';
const SET_BRANDING_SETTINGS_FAIL = 'admin/server/SET_BRANDING_SETTINGS_FAIL';
const SET_BRANDING_SETTINGS_SUCCESS =
  'admin/server/SET_BRANDING_SETTINGS_SUCCESS';

const BACKUP = 'admin/server/BACKUP';
const BACKUP_FAIL = 'admin/server/BACKUP_FAIL';
const BACKUP_SUCCESS = 'admin/server/BACKUP_SUCCESS';

const CANCEL_BACKUP = 'admin/server/CANCEL_BACKUP';
const CANCEL_BACKUP_FAIL = 'admin/server/CANCEL_BACKUP_FAIL';
const CANCEL_BACKUP_SUCCESS = 'admin/server/CANCEL_BACKUP_SUCCESS';

const RESTORE = 'admin/server/RESTORE';
const RESTORE_FAIL = 'admin/server/RESTORE_FAIL';
const RESTORE_SUCCESS = 'admin/server/RESTORE_SUCCESS';

const SET_IS_COMMUNICATING_WITH_DIR_SVC =
  'admin/server/SET_IS_COMMUNICATING_WITH_DIR_SVC';
const SET_IS_RESTARTING = 'admin/server/SET_IS_RESTARTING';
const SET_IS_ADMIN_SERVER_RESTARTING =
  'admin/server/SET_IS_ADMIN_SERVER_RESTARTING';
const SET_IS_SENDING_DIAGNOSTIC_DATA =
  'admin/server/SET_IS_SENDING_DIAGNOSTIC_DATA';

const SET_SERVER_STATUS = 'admin/server/SET_SERVER_STATUS';

const START_SERVER = 'admin/server/START_SERVER';
const START_SERVER_FAIL = 'admin/server/START_SERVER_FAIL';
const START_SERVER_SUCCESS = 'admin/server/START_SERVER_SUCCESS';

const STOP_SERVER = 'admin/server/STOP_SERVER';
const STOP_SERVER_FAIL = 'admin/server/STOP_SERVER_FAIL';
const STOP_SERVER_SUCCESS = 'admin/server/STOP_SERVER_SUCCESS';

const GET_SERVER_SYSTEM_INFORMATION =
  'admin/server/GET_SERVER_SYSTEM_INFORMATION';
const GET_SERVER_SYSTEM_INFORMATION_SUCCESS =
  'admin/server/GET_SERVER_SYSTEM_INFORMATION_SUCCESS';
const GET_SERVER_SYSTEM_INFORMATION_FAIL =
  'admin/server/GET_SERVER_SYSTEM_INFORMATION_FAIL';

const GET_SERVER_FOLDERS = 'admin/server/GET_SERVER_FOLDERS';
const GET_SERVER_FOLDERS_FAIL = 'admin/server/GET_SERVER_FOLDERS_FAIL';
const GET_SERVER_FOLDERS_SUCCESS = 'admin/server/GET_SERVER_FOLDERS_SUCCESS';

const SET_SSO_CREDENTIALS = 'admin/server/SET_SSO_CREDENTIALS';
const SET_SSO_CREDENTIALS_FAIL = 'admin/server/SET_SSO_CREDENTIALS_FAIL';
const SET_SSO_CREDENTIALS_SUCCESS = 'admin/server/SET_SSO_CREDENTIALS_SUCCESS';

const SET_GLOBAL_SETTINGS = 'admin/server/SET_GLOBAL_SETTINGS';
const SET_GLOBAL_SETTINGS_SUCCESS = 'admin/server/SET_GLOBAL_SETTINGS_SUCCESS';
const SET_GLOBAL_SETTINGS_FAIL = 'admin/server/SET_GLOBAL_SETTINGS_FAIL';

const SET_MOBILE_UPLOAD_SETTINGS = 'admin/server/SET_MOBILE_UPLOAD_SETTINGS';
const SET_MOBILE_UPLOAD_SETTINGS_SUCCESS =
  'admin/server/SET_MOBILE_UPLOAD_SETTINGS_SUCCESS';
const SET_MOBILE_UPLOAD_SETTINGS_FAIL =
  'admin/server/SET_MOBILE_UPLOAD_SETTINGS_FAIL';

const SET_LOGGING_CONFIG = 'admin/server/SET_LOGGING_CONFIG';
const SET_LOGGING_CONFIG_SUCCESS = 'admin/server/SET_LOGGING_CONFIG_SUCCESS';
const SET_LOGGING_CONFIG_FAIL = 'admin/server/SET_LOGGING_CONFIG_FAIL';

const UPDATE_DIR_SVC_DESC = 'admin/server/UPDATE_DIR_SVC_DESC';
const UPDATE_DIR_SVC_DESC_SUCCESS = 'admin/server/UPDATE_DIR_SVC_DESC_SUCCESS';
const UPDATE_DIR_SVC_DESC_FAIL = 'admin/server/UPDATE_DIR_SVC_DESC_FAIL';

const UPDATE_SERVER_FOLDERS = 'admin/server/UPDATE_SERVER_FOLDERS';
const UPDATE_SERVER_FOLDER_ROOT = 'admin/server/UPDATE_SERVER_FOLDER_ROOT';

const SET_EMAIL_CONFIG = 'admin/server/SET_EMAIL_CONFIG';
const SET_EMAIL_CONFIG_FAIL = 'admin/server/SET_EMAIL_CONFIG_FAIL';
const SET_EMAIL_CONFIG_SUCCESS = 'admin/server/SET_EMAIL_CONFIG_SUCCESS';

const SET_PORTS = 'admin/server/SET_PORTS';
const SET_PORTS_FAIL = 'admin/server/SET_PORTS_FAIL';
const SET_PORTS_SUCCESS = 'admin/server/SET_PORTS_SUCCESS';
const CREATE_MEDIA_ENGINE = 'admin/server/CREATE_MEDIA_ENGINE';
const CREATE_MEDIA_ENGINE_FAIL = 'admin/server/CREATE_MEDIA_ENGINE_FAIL';
const CREATE_MEDIA_ENGINE_SUCCESS = 'admin/server/CREATE_MEDIA_ENGINE_SUCCESS';

const DELETE_MEDIA_ENGINE = 'admin/server/DELETE_MEDIA_ENGINE';
const DELETE_MEDIA_ENGINE_FAIL = 'admin/server/DELETE_MEDIA_ENGINE_FAIL';
const DELETE_MEDIA_ENGINE_SUCCESS = 'admin/server/DELETE_MEDIA_ENGINE_SUCCESS';

const TEST_MEDIA_ENGINE = 'admin/server/TEST_MEDIA_ENGINE';
const TEST_MEDIA_ENGINE_FAIL = 'admin/server/TEST_MEDIA_ENGINE_FAIL';
const TEST_MEDIA_ENGINE_SUCCESS = 'admin/server/TEST_MEDIA_ENGINE_SUCCESS';

const UPDATE_MEDIA_ENGINE = 'admin/server/UPDATE_MEDIA_ENGINE';
const UPDATE_MEDIA_ENGINE_FAIL = 'admin/server/UPDATE_MEDIA_ENGINE_FAIL';
const UPDATE_MEDIA_ENGINE_SUCCESS = 'admin/server/UPDATE_MEDIA_ENGINE_SUCCESS';

const SET_BRANDING_IMAGE = 'admin/server/SET_BRANDING_IMAGE';
const SET_BRANDING_IMAGE_SUCCESS = 'admin/server/SET_BRANDING_IMAGE_SUCCESS';
const SET_BRANDING_IMAGE_FAIL = 'admin/server/SET_BRANDING_IMAGE_FAIL';

const VALIDATE_EMAIL_SERVER_CONFIG =
  'admin/server/VALIDATE_EMAIL_SERVER_CONFIG';
const VALIDATE_EMAIL_SERVER_CONFIG_FAIL =
  'admin/server/VALIDATE_EMAIL_SERVER_CONFIG_FAIL';
const VALIDATE_EMAIL_SERVER_CONFIG_SUCCESS =
  'admin/server/VALIDATE_EMAIL_SERVER_CONFIG_SUCCESS';

const SET_EMAIL_SERVER_CONFIG_VALIDATING =
  'admin/server/SET_EMAIL_SERVER_CONFIG_VALIDATING';
const CLEAR_EMAIL_SERVER_CONFIG_VALIDATING =
  'admin/server/CLEAR_EMAIL_SERVER_CONFIG_VALIDATING';

const SET_MEDIA_ENGINE_TEST_PENDING =
  'admin/server/SET_MEDIA_ENGINE_TEST_PENDING';
const CLEAR_MEDIA_ENGINE_TEST_PENDING =
  'admin/server/CLEAR_MEDIA_ENGINE_TEST_PENDING';

export {
  ADMIN_PROPERTIES_FAIL,
  ADMIN_PROPERTIES_SUCCESS,
  ADMIN_PROPERTIES,
  BACKUP,
  BACKUP_FAIL,
  BACKUP_SUCCESS,
  CANCEL_BACKUP,
  CANCEL_BACKUP_FAIL,
  CANCEL_BACKUP_SUCCESS,
  CLEAR_EMAIL_SERVER_CONFIG_VALIDATING,
  CLEAR_MEDIA_ENGINE_TEST_PENDING,
  CREATE_DIR_SVC_DESC,
  CREATE_DIR_SVC_DESC_SUCCESS,
  CREATE_DIR_SVC_DESC_FAIL,
  CREATE_MEDIA_ENGINE,
  CREATE_MEDIA_ENGINE_FAIL,
  CREATE_MEDIA_ENGINE_SUCCESS,
  DELETE_DIR_SVC_DESC,
  DELETE_DIR_SVC_DESC_SUCCESS,
  DELETE_DIR_SVC_DESC_FAIL,
  DELETE_MEDIA_ENGINE,
  DELETE_MEDIA_ENGINE_FAIL,
  DELETE_MEDIA_ENGINE_SUCCESS,
  GET_SERVER_FOLDERS,
  GET_SERVER_FOLDERS_FAIL,
  GET_SERVER_FOLDERS_SUCCESS,
  GET_SERVER_SYSTEM_INFORMATION,
  GET_SERVER_SYSTEM_INFORMATION_FAIL,
  GET_SERVER_SYSTEM_INFORMATION_SUCCESS,
  SET_SSO_CREDENTIALS,
  SET_SSO_CREDENTIALS_FAIL,
  SET_SSO_CREDENTIALS_SUCCESS,
  RESTART_SERVER_FAIL,
  RESTART_SERVER_SUCCESS,
  RESTART_SERVER,
  RESTORE,
  RESTORE_FAIL,
  RESTORE_SUCCESS,
  SEND_DIAGNOSTIC_DATA_FAIL,
  SEND_DIAGNOSTIC_DATA_SUCCESS,
  SEND_DIAGNOSTIC_DATA,
  SET_BACKUP_CONFIG,
  SET_BACKUP_CONFIG_FAIL,
  SET_BACKUP_CONFIG_SUCCESS,
  SET_BRANDING_IMAGE,
  SET_BRANDING_IMAGE_FAIL,
  SET_BRANDING_IMAGE_SUCCESS,
  SET_BRANDING_SETTINGS,
  SET_BRANDING_SETTINGS_FAIL,
  SET_BRANDING_SETTINGS_SUCCESS,
  SET_EMAIL_CONFIG,
  SET_EMAIL_CONFIG_FAIL,
  SET_EMAIL_CONFIG_SUCCESS,
  SET_EMAIL_SERVER_CONFIG_VALIDATING,
  SET_GLOBAL_SETTINGS,
  SET_GLOBAL_SETTINGS_FAIL,
  SET_GLOBAL_SETTINGS_SUCCESS,
  SET_IS_COMMUNICATING_WITH_DIR_SVC,
  SET_IS_RESTARTING,
  SET_IS_ADMIN_SERVER_RESTARTING,
  SET_IS_SENDING_DIAGNOSTIC_DATA,
  SET_LOGGING_CONFIG,
  SET_LOGGING_CONFIG_FAIL,
  SET_LOGGING_CONFIG_SUCCESS,
  SET_MOBILE_UPLOAD_SETTINGS,
  SET_MOBILE_UPLOAD_SETTINGS_FAIL,
  SET_MOBILE_UPLOAD_SETTINGS_SUCCESS,
  SET_MEDIA_ENGINE_TEST_PENDING,
  SET_PORTS,
  SET_PORTS_FAIL,
  SET_PORTS_SUCCESS,
  SET_SERVER_STATUS,
  START_SERVER_FAIL,
  START_SERVER_SUCCESS,
  START_SERVER,
  STOP_SERVER_FAIL,
  STOP_SERVER_SUCCESS,
  STOP_SERVER,
  TEST_MEDIA_ENGINE,
  TEST_MEDIA_ENGINE_FAIL,
  TEST_MEDIA_ENGINE_SUCCESS,
  UPDATE_DIR_SVC_DESC,
  UPDATE_DIR_SVC_DESC_SUCCESS,
  UPDATE_DIR_SVC_DESC_FAIL,
  UPDATE_MEDIA_ENGINE,
  UPDATE_MEDIA_ENGINE_FAIL,
  UPDATE_MEDIA_ENGINE_SUCCESS,
  UPDATE_SERVER_FOLDER_ROOT,
  UPDATE_SERVER_FOLDERS,
  VALIDATE_EMAIL_SERVER_CONFIG,
  VALIDATE_EMAIL_SERVER_CONFIG_FAIL,
  VALIDATE_EMAIL_SERVER_CONFIG_SUCCESS,
};

export type License = {
  dateAdded: string,
  dateExpires?: string,
  feature: string,
  isDemoMode: boolean,
  isExpiredLicense: boolean,
  numSeats: number,
  platform: string,
  productId: string,
  serialNumber: string,
  version: string,
};

export type MediaEngine = {
  enabled: boolean,
  address: string,
  id: string,
  port: number,
  type: string,
};

export type MediaEngineInfo = {
  clockSpeedInMegaHertz: number,
  isOperational: boolean,
  numberOfHardwareThreads: number,
};

export type ProductVersion = {
  componentName: string,
  versionNumber: string,
};

export type ServerStatusErrorMessage = {
  id: string,
  parameters: Object,
};

export type ServerStatus = {
  runState: string,
  accessState: string,
  versions: Array<ProductVersion>,
  errorMessages: Array<ServerStatusErrorMessage>,
  properties: Object,
};

export type DirectoryServiceDescription = {|
  uuid?: string,
  hostname?: string,
  port?: string,
  serviceType?: string,
  autoUpdate?: boolean,
  updateInterval?: number,
  deleteMissingUsersOnUpdate?: boolean,
  loginDN?: string,
  credential?: string,
  defaultSearchBase?: string,
  lastQuery?: string,
  useLdaps?: boolean,
|};

export type BackupConfiguration = {|
  areBackupsScheduled?: boolean,
  areBackupsScheduledSunday?: boolean,
  areBackupsScheduledMonday?: boolean,
  areBackupsScheduledTuesday?: boolean,
  areBackupsScheduledWednesday?: boolean,
  areBackupsScheduledThursday?: boolean,
  areBackupsScheduledFriday?: boolean,
  areBackupsScheduledSaturday?: boolean,
  backupsDirectory?: string,
  backupsRetainCount?: string,
  backupScheduledTime?: string,
  nextScheduledBackup?: string,
  mostRecentBackupFileName?: string,
  isEmailNotificationConfigured?: boolean,
|};

export type BackupOperationState =
  | 'BACKUP_PREFLIGHT'
  | 'BACKUP_SHUTTING_DOWN_SERVER'
  | 'BACKUP_BACKING_UP_DATA'
  | 'BACKUP_RESTARTING_SERVER'
  | 'BACKUP_COMPLETE'
  | 'BACKUP_FAILED'
  | 'BACKUP_CANCELLED'
  | 'RESTORE_SHUTTING_DOWN_SERVER'
  | 'RESTORE_RESTORE_DATA'
  | 'RESTORE_RESTARTING_SERVER'
  | 'RESTORE_COMPLETE'
  | 'RESTORE_FAILED'
  | 'NONE';

export type BackupRestoreStatus = {|
  currentOperationState: BackupOperationState,
  faultCode?: number,
  lastCompleteDate?: string,
  spaceAvailable?: number,
  spaceRequired?: number,
|};

export type BrandingSettings = {|
  useCustomBranding?: boolean,
  useCustomImage?: boolean,
  customImageFilename?: string,
  customURL?: string,
  customTitle?: string,
  customBackgroundColor?: string,
|};

export type EmailServerConfiguration = {|
  emailEnabled?: boolean,
  emailServerAddress?: string,
  emailServerPort?: string,
  emailUseSMTP?: boolean,
  emailUsername?: string,
  emailPassword?: string,
  emailUseSSLTLS?: boolean,
  emailFromAddress?: string,
|};

export type FileSystemObject = {
  name: string,
  type: 'file' | 'directory',
  attributes?: {},
};

export type LoggingConfig = {
  logDirectory?: string,
  logLevel?: string,
  retainCount?: number,
};

export const MOBILE_UPLOADS_ENABLED = 'mobile.uploads.enabled';
export const MOBILE_UPLOADS_FOLDER = 'default.upload.folder';
export const MOBILE_UPLOADS_CATALOG = 'mobile.uploads.catalog';

export type MobileUploadSettings = {
  MOBILE_UPLOADS_ENABLED?: string,
  MOBILE_UPLOADS_FOLDER?: string,
  MOBILE_UPLOADS_CATALOG?: string,
  locale?: string,
  catalogName?: string,
};

export const PORT_KEY_SERVER = 'esp.port.http';
export const PORT_KEY_SERVER_HTTPS = 'esp.port.https';
export const PORT_KEY_ADMIN = 'esp.port.admin-web-app';
export const PORT_KEY_ADMIN_SSL = 'esp.port.admin-web-app-ssl';

export type Ports = {
  'esp.port.http'?: number,
  'esp.port.https'?: number,
  'esp.port.admin-web-app'?: number,
  'esp.port.admin-web-app-ssl'?: number,
};

export type ServerFolder = {|
  displayName: string,
  fullPath: string,
  isExpanded?: boolean,
  s?: ServerFolder[],
  type: 'file' | 'directory',
|};

type ServerSystemInformation = {
  'host-name': string,
  platform: 'PLATFORM_WINDOWS' | 'PLATFORM_OSX',
};

export type ReachoutMessage = {
  endDate: string,
  id: string,
  targetApps: Array<string>,
  text: string,
  url: string,
  urlText: string,
};

export type GlobalSettings = {
  +'client.default.user.access.level'?: string,
  +'default.upload.folder'?: string,
  +'mobile.uploads.catalog'?: string,
  +'mobile.uploads.enabled'?: string,
  +'server.create.autosync.folder'?: string,
  +'server.default.autosync.folder'?: string,
  +'server.default.logging.dir'?: string,
  +'server.default.previews.folder'?: string,
  +'server.default.work.folder'?: string,
  +'server.save.previews'?: string,
  +'server.vault.home'?: string,
  +'server.vault.home.default'?: string,
  +'server.work.folder'?: string,
  +'server.work.folder.transitional'?: string,
  +'server.sso.principal'?: string,
};

export type AdminProperties = {
  +backupConfig?: BackupConfiguration,
  +backupRestoreStatus?: BackupRestoreStatus,
  +brandingSettings?: BrandingSettings,
  +diagnosticDataStatus?: string,
  +directoryServiceDescription?: DirectoryServiceDescription,
  +emailServerConfiguration?: EmailServerConfiguration,
  +emailConfigValidationPending: boolean,
  +serverStatus?: ServerStatus,
  +globalStatistics?: {
    +totalAssetCount: number,
    +seatCount: number,
    +smartKeywordsRemainingCount: number,
  },
  +mediaEngines?: Array<MediaEngine>,
  +mediaEngineTestPending: boolean,
  +licenses?: Array<License>,
  +loggingConfig?: LoggingConfig,
  +isCommunicatingWithDirectoryService: boolean,
  +isRestarting: boolean,
  +isAdminServerRestarting: boolean,
  +isSendingDiagnosticData: boolean,
  +serverFolders: ServerFolder[],
  +serverFolderRoot: string,
  +serverOsPlatform: 'PLATFORM_WINDOWS' | 'PLATFORM_OSX',
  +ports?: Ports,
  +reachoutMessages?: Array<ReachoutMessage>,
  +globalSettings?: GlobalSettings,
};

export type LicensedFeatures = {
  api: boolean,
  main: boolean,
  me: boolean,
  np: boolean,
  sk: boolean,
  sso: boolean,
  dirSvc: boolean,
};

type AdminPropertiesAction = {|
  type: 'admin/server/ADMIN_PROPERTIES',
  payload: {|
    +adminSession: string,
    +identitySession: string,
  |},
|};

type AdminPropertiesFailAction = {|
  type: 'admin/server/ADMIN_PROPERTIES_FAIL',
|};

type AdminPropertiesSuccessAction = {|
  type: 'admin/server/ADMIN_PROPERTIES_SUCCESS',
  payload: AdminProperties,
|};

type BackupAction = {|
  type: 'admin/server/BACKUP',
|};

type BackupFailAction = {|
  type: 'admin/server/BACKUP_FAIL',
|};

type BackupSuccessAction = {| type: 'admin/server/BACKUP_SUCCESS' |};

type CancelBackupAction = {| type: 'admin/server/CANCEL_BACKUP' |};

type CancelBackupFailAction = {| type: 'admin/server/CANCEL_BACKUP_FAIL' |};

type CancelBackupSuccessAction = {|
  type: 'admin/server/CANCEL_BACKUP_SUCCESS',
|};

type CreateDirectoryServiceDescriptionAction = {|
  type: 'admin/server/CREATE_DIR_SVC_DESC',
  payload: { session: string, description: DirectoryServiceDescription },
|};

type CreateDirectoryServiceDescriptionFailAction = {|
  type: 'admin/server/CREATE_DIR_SVC_DESC_FAIL',
|};

type CreateDirectoryServiceDescriptionSuccessAction = {|
  type: 'admin/server/CREATE_DIR_SVC_DESC_SUCCESS',
|};

type DeleteDirectoryServiceDescriptionAction = {|
  type: 'admin/server/DELETE_DIR_SVC_DESC',
  payload: { session: string, uuid: string },
|};

type DeleteDirectoryServiceDescriptionFailAction = {|
  type: 'admin/server/DELETE_DIR_SVC_DESC_FAIL',
|};

type DeleteDirectoryServiceDescriptionSuccessAction = {|
  type: 'admin/server/DELETE_DIR_SVC_DESC_SUCCESS',
|};

type RestartServerAction = {|
  type: 'admin/server/RESTART_SERVER',
  payload: { session: string },
|};

type RestartServerFailAction = {|
  type: 'admin/server/RESTART_SERVER_FAIL',
|};

type RestartServerSuccessAction = {|
  type: 'admin/server/RESTART_SERVER_SUCCESS',
|};

type RestoreAction = {|
  type: 'admin/server/RESTORE',
|};

type RestoreFailAction = {|
  type: 'admin/server/RESTORE_FAIL',
|};

type RestoreSuccessAction = {|
  type: 'admin/server/RESTORE_SUCCESS',
|};

type SendDiagnosticDataStatusAction = {|
  type: 'admin/server/SEND_DIAGNOSTIC_DATA',
  payload: { session: string },
|};

type SendDiagnosticDataStatusFailAction = {|
  type: 'admin/server/SEND_DIAGNOSTIC_DATA_FAIL',
|};

type SendDiagnosticDataStatusSuccessAction = {|
  type: 'admin/server/SEND_DIAGNOSTIC_DATA_SUCCESS',
|};

type SetBackupConfigAction = {|
  type: 'admin/server/SET_BACKUP_CONFIG',
  payload: { session: string, backupConfig: BackupConfiguration },
|};

type SetBackupConfigFailAction = {|
  type: 'admin/server/SET_BACKUP_CONFIG_FAIL',
|};

type SetBackupConfigSuccessAction = {|
  type: 'admin/server/SET_BACKUP_CONFIG_SUCCESS',
|};

type SetBrandingSettingsAction = {|
  type: 'admin/server/SET_BRANDING_SETTINGS',
  payload: { session: string, config: BrandingSettings },
|};

type SetBrandingSettingsFailAction = {|
  type: 'admin/server/SET_BRANDING_SETTINGS_FAIL',
|};

type SetBrandingSettingsSuccessAction = {|
  type: 'admin/server/SET_BRANDING_SETTINGS_SUCCESS',
|};

type SetEmailServerConfigurationAction = {|
  type: 'admin/server/SET_EMAIL_CONFIG',
  payload: { session: string, config: EmailServerConfiguration },
|};

type SetEmailServerConfigurationFailAction = {|
  type: 'admin/server/SET_EMAIL_CONFIG_FAIL',
|};

type SetEmailServerConfigurationSuccessAction = {|
  type: 'admin/server/SET_EMAIL_CONFIG_SUCCESS',
|};

type SetPortsAction = {|
  type: 'admin/server/SET_PORTS',
  payload: { session: string, ports: Ports },
|};

type SetPortsFailAction = {|
  type: 'admin/server/SET_PORTS_FAIL',
|};

type SetPortsSuccessAction = {|
  type: 'admin/server/SET_PORTS_SUCCESS',
|};

type SetGlobalSettingsAction = {|
  type: 'admin/server/SET_GLOBAL_SETTINGS',
  payload: { session: string, settings: any },
|};

type SetGlobalSettingsFailAction = {|
  type: 'admin/server/SET_GLOBAL_SETTINGS_FAIL',
|};

type SetGlobalSettingsSuccessAction = {|
  type: 'admin/server/SET_GLOBAL_SETTINGS_SUCCESS',
|};

type SetMobileUploadSettingsAction = {|
  type: 'admin/server/SET_MOBILE_UPLOAD_SETTINGS',
  payload: { adminSession: string, identSession: string, settings: any },
|};

type SetMobileUploadSettingsFailAction = {|
  type: 'admin/server/SET_MOBILE_UPLOAD_SETTINGS_FAIL',
|};

type SetMobileUploadSettingsSuccessAction = {|
  type: 'admin/server/SET_MOBILE_UPLOAD_SETTINGS_SUCCESS',
|};

type SetIsRestartingAction = {|
  type: 'admin/server/SET_IS_RESTARTING',
  payload: boolean,
|};

type SetIsAdminServerRestartingAction = {|
  type: 'admin/server/SET_IS_ADMIN_SERVER_RESTARTING',
  payload: boolean,
|};

type SetIsSendingDiagnosticDataAction = {|
  type: 'admin/server/SET_IS_SENDING_DIAGNOSTIC_DATA',
  payload: boolean,
|};

type SetLoggingConfigAction = {|
  type: 'admin/server/SET_LOGGING_CONFIG',
  payload: { session: string, config: LoggingConfig },
|};

type SetLoggingConfigFailAction = {|
  type: 'admin/server/SET_LOGGING_CONFIG_FAIL',
|};

type SetLoggingConfigSuccessAction = {|
  type: 'admin/server/SET_LOGGING_CONFIG_SUCCESS',
|};

type SetServerStatusAction = {|
  type: 'admin/server/SET_SERVER_STATUS',
  payload: string,
|};

type StartServerAction = {|
  type: 'admin/server/START_SERVER',
  payload: { session: string },
|};

type StartServerFailAction = {|
  type: 'admin/server/START_SERVER_FAIL',
|};

type StartServerSuccessAction = {|
  type: 'admin/server/START_SERVER_SUCCESS',
|};

type StopServerAction = {|
  type: 'admin/server/STOP_SERVER',
  payload: { session: string },
|};

type StopServerFailAction = {|
  type: 'admin/server/STOP_SERVER_FAIL',
|};

type StopServerSuccessAction = {|
  type: 'admin/server/STOP_SERVER_SUCCESS',
|};

type GetServerSystemInformationAction = {|
  type: 'admin/server/GET_SERVER_SYSTEM_INFORMATION',
|};

type GetServerSystemInformationFailAction = {|
  type: 'admin/server/GET_SERVER_SYSTEM_INFORMATION_FAIL',
|};

type GetServerSystemInformationSuccessAction = {|
  type: 'admin/server/GET_SERVER_SYSTEM_INFORMATION_SUCCESS',
  payload: ServerSystemInformation,
|};

type UpdateServerFolderRootAction = {|
  type: 'admin/server/UPDATE_SERVER_FOLDER_ROOT',
  payload: string,
|};

type GetServerFoldersAction = {|
  type: 'admin/server/GET_SERVER_FOLDERS',
|};

type GetServerFoldersFailAction = {|
  type: 'admin/server/GET_SERVER_FOLDERS_FAIL',
|};

type GetServerFoldersSuccessAction = {|
  type: 'admin/server/GET_SERVER_FOLDERS_SUCCESS',
  payload: FileSystemObject[],
  meta: { path: string },
|};

type SetIsCommunicatingWithDirectoryService = {|
  type: 'admin/server/SET_IS_COMMUNICATING_WITH_DIR_SVC',
  payload: boolean,
|};

type UpdateServerFoldersAction = {|
  type: 'admin/server/UPDATE_SERVER_FOLDERS',
  payload: ServerFolder[],
|};

type UpdateDirectoryServiceDescriptionAction = {|
  type: 'admin/server/UPDATE_DIR_SVC_DESC',
  payload: { session: string, description: DirectoryServiceDescription },
|};

type UpdateDirectoryServiceDescriptionFailAction = {|
  type: 'admin/server/UPDATE_DIR_SVC_DESC_FAIL',
|};

type UpdateDirectoryServiceDescriptionSuccessAction = {|
  type: 'admin/server/UPDATE_DIR_SVC_DESC_SUCCESS',
|};

type SetSingleSignOnCredentialsAction = {|
  type: 'admin/server/SET_SSO_CREDENTIALS',
  payload: {
    username: string,
    encryptedPassword: string,
  },
|};

type SetSingleSignOnCredentialsFailAction = {|
  type: 'admin/server/SET_SSO_CREDENTIALS_FAIL',
|};

type SetSingleSignOnCredentialsSuccessAction = {|
  type: 'admin/server/SET_SSO_CREDENTIALS_SUCCESS',
|};

type CreateMediaEngineAction = {|
  type: 'admin/server/CREATE_MEDIA_ENGINE',
  payload: MediaEngine,
|};

type CreateMediaEngineFailAction = {|
  type: 'admin/server/CREATE_MEDIA_ENGINE_FAIL',
|};

type CreateMediaEngineSuccessAction = {|
  type: 'admin/server/CREATE_MEDIA_ENGINE_SUCCESS',
|};

type DeleteMediaEngineAction = {|
  type: 'admin/server/DELETE_MEDIA_ENGINE',
|};

type DeleteMediaEngineFailAction = {|
  type: 'admin/server/DELETE_MEDIA_ENGINE_FAIL',
|};

type DeleteMediaEngineSuccessAction = {|
  type: 'admin/server/DELETE_MEDIA_ENGINE_SUCCESS',
|};

type TestMediaEngineAction = {|
  type: 'admin/server/TEST_MEDIA_ENGINE',
  payload: {
    session: string,
    mediaEngine: MediaEngine,
  },
|};

type TestMediaEngineFailAction = {|
  type: 'admin/server/TEST_MEDIA_ENGINE_FAIL',
|};

type TestMediaEngineSuccessAction = {|
  type: 'admin/server/TEST_MEDIA_ENGINE_SUCCESS',
  payload: MediaEngineInfo,
|};

type UpdateMediaEngineAction = {|
  type: 'admin/server/UPDATE_MEDIA_ENGINE',
  payload: {
    mediaEngine: MediaEngine,
  },
|};

type UpdateMediaEngineFailAction = {|
  type: 'admin/server/UPDATE_MEDIA_ENGINE_FAIL',
|};

type UpdateMediaEngineSuccessAction = {|
  type: 'admin/server/UPDATE_MEDIA_ENGINE_SUCCESS',
|};

type ValidateEmailServerConfigAction = {|
  type: 'admin/server/VALIDATE_EMAIL_SERVER_CONFIG',
|};

type ValidateEmailServerConfigSuccessAction = {|
  type: 'admin/server/VALIDATE_EMAIL_SERVER_CONFIG_SUCCESS',
|};

type ValidateEmailServerConfigFailAction = {|
  type: 'admin/server/VALIDATE_EMAIL_SERVER_CONFIG_FAIL',
|};

type SetEmailServerConfigValidatingAction = {|
  type: 'admin/server/SET_EMAIL_SERVER_CONFIG_VALIDATING',
|};
type ClearEmailServerConfigValidatingAction = {|
  type: 'admin/server/CLEAR_EMAIL_SERVER_CONFIG_VALIDATING',
|};

type SetMediaEngineTestPendingAction = {|
  type: 'admin/server/SET_MEDIA_ENGINE_TEST_PENDING',
|};
type ClearMediaEngineTestPendingAction = {|
  type: 'admin/server/CLEAR_MEDIA_ENGINE_TEST_PENDING',
|};

export type Action =
  | AdminPropertiesAction
  | AdminPropertiesFailAction
  | AdminPropertiesSuccessAction
  | BackupAction
  | BackupFailAction
  | BackupSuccessAction
  | CancelBackupAction
  | CancelBackupFailAction
  | CancelBackupSuccessAction
  | ClearEmailServerConfigValidatingAction
  | ClearMediaEngineTestPendingAction
  | CreateMediaEngineAction
  | CreateMediaEngineFailAction
  | CreateMediaEngineSuccessAction
  | CreateDirectoryServiceDescriptionAction
  | CreateDirectoryServiceDescriptionFailAction
  | CreateDirectoryServiceDescriptionSuccessAction
  | DeleteDirectoryServiceDescriptionAction
  | DeleteDirectoryServiceDescriptionFailAction
  | DeleteDirectoryServiceDescriptionSuccessAction
  | DeleteMediaEngineAction
  | DeleteMediaEngineFailAction
  | DeleteMediaEngineSuccessAction
  | GetServerFoldersAction
  | GetServerFoldersFailAction
  | GetServerFoldersSuccessAction
  | GetServerSystemInformationAction
  | GetServerSystemInformationFailAction
  | GetServerSystemInformationSuccessAction
  | RestartServerAction
  | RestartServerFailAction
  | RestartServerSuccessAction
  | RestoreAction
  | RestoreFailAction
  | RestoreSuccessAction
  | SendDiagnosticDataStatusAction
  | SendDiagnosticDataStatusFailAction
  | SendDiagnosticDataStatusSuccessAction
  | SetBackupConfigAction
  | SetBackupConfigFailAction
  | SetBackupConfigSuccessAction
  | SetBrandingSettingsAction
  | SetBrandingSettingsFailAction
  | SetBrandingSettingsSuccessAction
  | SetEmailServerConfigurationAction
  | SetEmailServerConfigurationFailAction
  | SetEmailServerConfigurationSuccessAction
  | SetEmailServerConfigValidatingAction
  | SetGlobalSettingsAction
  | SetGlobalSettingsSuccessAction
  | SetGlobalSettingsFailAction
  | SetMobileUploadSettingsAction
  | SetMobileUploadSettingsSuccessAction
  | SetMobileUploadSettingsFailAction
  | SetIsCommunicatingWithDirectoryService
  | SetIsRestartingAction
  | SetIsAdminServerRestartingAction
  | SetIsSendingDiagnosticDataAction
  | SetLoggingConfigAction
  | SetLoggingConfigFailAction
  | SetLoggingConfigSuccessAction
  | SetMediaEngineTestPendingAction
  | SetPortsAction
  | SetPortsSuccessAction
  | SetPortsFailAction
  | SetServerStatusAction
  | SetSingleSignOnCredentialsAction
  | SetSingleSignOnCredentialsFailAction
  | SetSingleSignOnCredentialsSuccessAction
  | StartServerAction
  | StartServerFailAction
  | StartServerSuccessAction
  | StopServerAction
  | StopServerFailAction
  | StopServerSuccessAction
  | TestMediaEngineAction
  | TestMediaEngineFailAction
  | TestMediaEngineSuccessAction
  | UpdateDirectoryServiceDescriptionAction
  | UpdateDirectoryServiceDescriptionFailAction
  | UpdateDirectoryServiceDescriptionSuccessAction
  | UpdateMediaEngineAction
  | UpdateMediaEngineFailAction
  | UpdateMediaEngineSuccessAction
  | UpdateServerFolderRootAction
  | UpdateServerFolderRootAction
  | UpdateServerFoldersAction
  | ValidateEmailServerConfigAction
  | ValidateEmailServerConfigFailAction
  | ValidateEmailServerConfigSuccessAction;



// WEBPACK FOOTER //
// ./src/state/types/serverTypes.js